'use strict';

var StrategyAccordionDirective = function StrategyAccordionDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/strategy-accordion.html'),
    scope: {
      name: '@',
      idPrefix: '@',
      categories: '=',
      selectElement: '=onSelect'
    }
  };
};
StrategyAccordionDirective.$inject = [];
module.exports = StrategyAccordionDirective;